import { useEffect, useRef } from 'react'; // <-- Import useRef
import { useLocation } from 'react-router-dom';
import { useLoading } from '../context/LoadingContext';

const RouteChangeHandler = () => {
  const { showLoader, hideLoader } = useLoading();
  const location = useLocation();

  // Use a ref to store the previous location
  // This prevents the component from re-running and canceling the timer
  const prevLocationRef = useRef(location.pathname);

  useEffect(() => {
    // Check if the path has actually changed
    if (location.pathname !== prevLocationRef.current) {

      // 1. Scroll to top
      window.scrollTo(0, 0);

      // 2. Show the loader
      showLoader();

      // 3. Update the ref to the new path
      prevLocationRef.current = location.pathname;

      // 4. Set a timer to hide the loader after 500ms
      const timer = setTimeout(() => {
        hideLoader();
      }, 500); // <-- Set to 500ms to match the index page preloader

      // 4. Clean up the timer if the component unmounts
      return () => clearTimeout(timer);
    }

    // We only want this effect to run when the location.pathname changes
  }, [location.pathname, showLoader, hideLoader]);

  return null; // This component renders nothing
};

export default RouteChangeHandler;